export enum DateFormat {
  GENERAL = 'MM/DD/YY',
  FULL_YEAR = 'MMDDYYYY',
  TIME = 'h:mm A',
  PLAYER = 'HH:mm:ss',
  IMAGE = 'YY-MM-DD-HH-mm-ss',
}
